import { eachDayOfInterval, eachWeekOfInterval, endOfWeek } from 'date-fns'

/**
 * 月表示カレンダーのテーブルを作成するための関数
 * 月初日の週の日曜日 ~ 月末日の週の土曜日までを取得
 */
export const getCalendarArray = (start: Date, end: Date) => {
  const sundays = eachWeekOfInterval({
    start: start,
    end: end,
  })
  return sundays.map((sunday) => eachDayOfInterval({ start: sunday, end: endOfWeek(sunday) }))
}
